import React from "react"

import { ReportProblemOutlined as RequestErrorIcon } from "@material-ui/icons"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"
import BlockBodySectionRequiredCondition from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionRequiredCondition"

import { getConditionRuleByValidationSlug } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type RequestErrorConditionSectionProps = {
	nextChatBotFlowBlockRules: ChatBotFlowBlockRule[]
	text: string
}

const RequestErrorConditionSection: React.FC<RequestErrorConditionSectionProps> = (props) => {
	const {
		nextChatBotFlowBlockRules,
		text
	} = props

	const requestErrorConditionRule = getConditionRuleByValidationSlug("superlogica-api-error", nextChatBotFlowBlockRules)

	if (!requestErrorConditionRule) {
		return null
	}

	return (
		<BlockBodySection>
			<BlockBodySectionHandle
				chatBotFlowBlockRule={requestErrorConditionRule}
			>
				<BlockBodySectionRequiredCondition
					text={text}
					icon={<RequestErrorIcon />}
				/>
			</BlockBodySectionHandle>
		</BlockBodySection>
	)
}

export default RequestErrorConditionSection
